import { cva as t } from "../../modules/index.es4.js";
const i = t(
  "flex w-full rounded-lg text-base text-foreground ring-offset-background placeholder:text-gray-700 disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus:outline-none focus-visible:border-primary dark:bg-black dark:placeholder:text-foreground dark:disabled:bg-gray-50/30",
  {
    variants: {
      variant: {
        input: "bg-surface-50 px-4 border-2 border-gray-400",
        filter: "px-4 bg-background border border-gray-200 placeholder:text-sm"
      },
      size: {
        sm: "",
        md: "",
        lg: ""
      },
      type: {
        default: "",
        file: ""
      }
    },
    compoundVariants: [
      // Type
      {
        type: "file",
        variant: "input",
        class: "file:border-0 file:bg-primary file:text-primary-foreground file:text-sm file:font-medium file:rounded-lg"
      },
      // Input
      {
        variant: "input",
        size: "sm",
        class: "h-12 py-1.5 file:px-2 file:py-1 file:mt-1 file:mr-3"
      },
      {
        variant: "input",
        size: "md",
        class: "h-[3.25rem] py-2 file:px-2 file:py-1 file:mt-0.5 file:mr-3"
      },
      {
        variant: "input",
        size: "lg",
        class: "h-[4rem] py-2 file:px-3 file:py-2 file:mt-1 file:mr-3"
      },
      // filter
      {
        variant: "filter",
        size: "sm",
        class: "h-9"
      },
      {
        variant: "filter",
        size: "md",
        class: "h-[48px]"
      },
      {
        variant: "filter",
        size: "lg",
        class: "h-[56px]"
      }
    ],
    defaultVariants: {
      variant: "input",
      type: "default",
      size: "md"
    }
  }
), a = t("right-2 absolute text-gray-700", {
  variants: {
    variant: {
      input: "",
      filter: ""
    },
    size: {
      sm: "top-2.5",
      md: "top-3",
      lg: "top-[18px]"
    }
  },
  compoundVariants: [
    // Filter
    {
      variant: "filter",
      size: "sm",
      class: "top-1"
    },
    {
      variant: "filter",
      size: "md",
      class: "top-2.5"
    },
    {
      variant: "filter",
      size: "lg",
      class: "top-3.5"
    }
  ],
  defaultVariants: {
    variant: "input",
    size: "md"
  }
}), r = t(
  "left-3.5 absolute text-gray-700 pointer-events-none",
  {
    variants: {
      variant: {
        input: "",
        filter: ""
      },
      size: {
        sm: "top-4",
        md: "top-[18px]",
        lg: "top-6"
      }
    },
    compoundVariants: [
      // Filter
      {
        variant: "filter",
        size: "sm",
        class: "top-2.5"
      },
      {
        variant: "filter",
        size: "md",
        class: "top-4"
      },
      {
        variant: "filter",
        size: "lg",
        class: "top-5"
      }
    ],
    defaultVariants: {
      variant: "input",
      size: "md"
    }
  }
);
export {
  r as iconVariants,
  i as inputVariants,
  a as passwordButtonVariants
};
//# sourceMappingURL=Input.styles.es.js.map
